import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import { toast } from "react-toastify";
import {
  getAllServiceReferrals,
  serviceAdd,
  subServiceList,
  updateServicedata,
  updateServiceOnlineStatus,
  updateServiceToggle,
  updateSubCategoryStatus,
  updateSubCategoryToggle,
} from "../../Services/Operations/ProductAPI";
import { Section } from "../../Core/Section";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { baseURL } from "../../Services/api_endpoints";

const Service = () => {
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [cartUpdated, setServiceUpdated] = useState(false);
  const [SubcategoryUpdated, setSubcategoryUpdated] = useState(false);
  const [service, setService] = useState([]);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [shortname, setShortName] = useState("");
  const [img, setImg] = useState(null);
  const [formData, setFormData] = useState({
    // this for add new service
    serviceName: "",
    serviceDescription: "",
    serviceShortName: "",
    serviceImageFile: null,
  });

  const [formEditData, setFormEditData] = useState({
    serviceName: "",
    serviceDescription: "",
    serviceShortName: "",
    serviceImageFile: null,
  });

  const [showModal, setShowModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const [showServiceReferralsModal, setShowServiceReferralsModal] =
    useState(false);
  const [serviceReferrals, setServiceReferrals] = useState([]);
  const [referralsLoading, setReferralsLoading] = useState(false);

  const fetchServiceList = async () => {
    try {
      const response = await subServiceList(token);
      console.log("service list:", response);
      setService(Array.isArray(response) ? response : []);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleViewDetails = (service) => {
    setSelectedService(service);
    setShowModal(true);
  };

  const handleViewEdit = (service) => {
    console.log(service);

    setSelectedService(service);
    setName(service?.serviceName);
    setDesc(service?.serviceDescription);
    setShortName(service?.serviceShortName || "");
    setImg(service?.serviceImage);
    //   setFormEditData({
    //      serviceName:,
    //   serviceDescription: ,
    //  serviceShortName:,
    //   serviceImageFile:
    //   })
    setEditModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedService(null);
  };
  const handleEditCloseModal = () => {
    setEditModal(false);
    setSelectedService(null);
  };

  const toggleOnlineStatus = async (id) => {
    try {
      const response = await updateServiceOnlineStatus(id, token);
      console.log("online status :", response);
      if (response.data.status === "success") {
        setSubcategoryUpdated((prev) => !prev);
        fetchServiceList();
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const toggleStatus = async (id) => {
    try {
      const response = await updateServiceToggle(id, token);
      console.log("toggle status :", response);
      if (response.data.status === "success") {
        setSubcategoryUpdated((prev) => !prev);
        fetchServiceList();
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setFormEditData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await serviceAdd(formDataToSend, token);
      console.log("Service add response:", response);

      if (response.status === 200) {
        toast.success("Service added successfully");
        setServiceUpdated((prev) => !prev);
        setFormData({
          serviceName: "",
          serviceDescription: "",
          serviceShortName: "",
          serviceImageFile: null,
        });
      } else {
        toast.error(response.data?.message || "Failed to add service");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error adding service");
    }
  };

  const EditSubmit = async () => {
    setFormEditData({
      serviceName: name,
      serviceDescription: desc,
      serviceShortName: shortname,
      serviceImageFile: img,
    });
    const formData = new FormData();
    formData.append("serviceName", name);
    formData.append("serviceDescription", desc);
    formData.append("serviceShortName", shortname);
    formData.append("serviceImageFile", img);
    try {
      const res = await updateServicedata(selectedService.id, formData, token);
      console.log(res);
      if (res.status === 200) {
        toast.success("Service updated successfully");
        handleEditCloseModal();
        fetchServiceList();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchServiceList();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;

  const currentServices = service?.slice(indexOfFirst, indexOfLast);

  const handleGetServiceReferrals = async () => {
    setShowServiceReferralsModal(true);
    setReferralsLoading(true);

    try {
      const response = await getAllServiceReferrals(token);
      console.log("All service Referrals:", response);
      setServiceReferrals(response?.data || []);
    } catch (error) {
      console.error("Error fetching product referrals:", error);
      toast.error("Failed to fetch product referrals");
    } finally {
      setReferralsLoading(false);
    }
  };

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Services</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Services
                  </li>
                </ol>
              </div>
              <ul className="nav nav-tabs page-header-tab">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#Student-all"
                  >
                    List View
                  </a>
                </li>
                <li className="nav-item">
                  <button
                    className="doctor-primary-btn"
                    style={{ backgroundColor: "#0972c7" }}
                    data-toggle="tab"
                    onClick={handleGetServiceReferrals}
                  >
                    All referrals
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className="doctor-primary-btn"
                    data-toggle="tab"
                    href="#Student-add"
                  >
                    Add New
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Student-all">
                <div className="table-responsive card">
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Id</th>
                        <th style={{ textAlign: "center" }}>serviceName</th>

                        <th style={{ textAlign: "center" }}>image</th>
                        <th style={{ textAlign: "center" }}>online status</th>
                        <th style={{ textAlign: "center" }}>status</th>
                        <th style={{ textAlign: "center" }}>action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentServices?.map((service, ind) => (
                        <tr key={service?.id}>
                          <td>{indexOfFirst + ind + 1}</td>
                          <td>{service?.serviceName}</td>

                          <td>
                            <img
                              src={baseURL + "api" + service?.serviceImage}
                              style={{ width: "50px", borderRadius: "50%" }}
                            />
                          </td>
                          <td>
                            <button
                              className={`btn btn-sm ${
                                service?.onlineAvailable
                                  ? "btn-primary"
                                  : "btn-danger"
                              }`}
                              onClick={() => toggleOnlineStatus(service?.id)}
                            >
                              {service?.onlineAvailable === 1
                                ? "Active"
                                : "Inactive"}
                            </button>
                          </td>
                          <td>
                            <button
                              className={`btn btn-sm ${
                                service?.status ? "btn-primary" : "btn-danger"
                              }`}
                              onClick={() => toggleStatus(service?.id)}
                            >
                              {service?.status === 1 ? "Active" : "Inactive"}
                            </button>
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                              onClick={() => handleViewDetails(service)}
                            >
                              <i className="fa fa-eye" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="Edit"
                              onClick={() => handleViewEdit(service)}
                            >
                              <i className="fa fa-edit" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div
                    className="pagination mt-3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      className="btn btn-primary btn-sm me-2"
                    >
                      Prev
                    </button>

                    <span>
                      {" "}
                      Page {currentPage} of{" "}
                      {Math.ceil(service.length / itemsPerPage)}{" "}
                    </span>

                    <button
                      disabled={
                        currentPage === Math.ceil(service.length / itemsPerPage)
                      }
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      className="btn btn-primary btn-sm ms-2"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>

              <div className="tab-pane" id="Student-add">
                <div className="row clearfix">
                  <div className="col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Basic Information</h3>
                        <div className="card-options "></div>
                      </div>
                      <form className="card-body" onSubmit={handleSubmit}>
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Service Name
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              name="serviceName"
                              placeholder="Enter Service Name"
                              value={formData.serviceName}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Service Short Name
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              name="serviceShortName"
                              placeholder="Enter Service Short Name"
                              value={formData.serviceShortName}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Service Description
                          </label>
                          <div className="col-md-9">
                            <textarea
                              className="form-control"
                              name="serviceDescription"
                              placeholder="Enter Service Description"
                              value={formData.serviceDescription}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Service Image
                          </label>
                          <div className="col-md-9">
                            <input
                              className="form-control"
                              name="serviceDescription"
                              type="file"
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  serviceImageFile: e.target.files[0],
                                });
                              }}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-sm-12">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  {/* <div className="col-lg-4 col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Account Information</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row clearfix">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>Service Name</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Password</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Confirm Password</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <button type="submit" className="btn btn-primary">
                              Submit
                            </button>
                            <button
                              type="submit"
                              className="btn btn-outline-secondary"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Account Information</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="form-group">
                          <label>Facebook</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>Twitter</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>LinkedIN</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>Behance</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>dribbble</label>
                          <input type="text" className="form-control" />
                        </div>
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                        <button
                          type="submit"
                          className="btn btn-outline-secondary"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={showModal} onHide={handleCloseModal} size="md">
          <Modal.Header closeButton>
            <Modal.Title>Service Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedService ? (
              <div>
                <div style={{ height: "150px", width: "150px" }}>
                  <img
                    style={{
                      objectFit: "contain",
                      height: "100%",
                      width: "100%",
                    }}
                    src={baseURL + "api" + selectedService?.serviceImage}
                  />
                </div>
                <p>
                  <strong>ID:</strong> {selectedService.id}
                </p>
                <p>
                  <strong>Service Name:</strong> {selectedService.serviceName}
                </p>
                <p>
                  <strong>Description:</strong>{" "}
                  {selectedService.serviceDescription}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  {selectedService.status ? "Active" : "Inactive"}
                </p>
              </div>
            ) : (
              <p>No details available</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* update modal */}
        <Modal show={editModal} onHide={handleEditCloseModal} size="md">
          <Modal.Header closeButton>
            <Modal.Title>Service Edit</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedService ? (
              <div>
                <p>
                  <strong>ID:</strong> {selectedService.id}
                </p>
                <p>
                  <strong>Service Name:</strong>
                  <input
                    name="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </p>
                <p>
                  <strong>Description:</strong>{" "}
                  <input
                    name="desc"
                    value={desc}
                    onChange={(e) => setDesc(e.target.value)}
                  />
                </p>
                <p>
                  <strong>Short Name:</strong>{" "}
                  <input
                    name="shortname"
                    value={shortname}
                    onChange={(e) => setShortName(e.target.value)}
                  />
                </p>
                <p>
                  <strong>Image:</strong>{" "}
                  <input
                    name="img"
                    type="file"
                    onChange={(e) => setImg(e.target.files[0])}
                  />
                </p>
                <Button variant="secondary" onClick={EditSubmit}>
                  Edit
                </Button>
              </div>
            ) : (
              <p>No details available</p>
            )}
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>

        {showServiceReferralsModal && (
          <div
            onClick={() => setShowServiceReferralsModal(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(20, 25, 35, 0.55)",
              backdropFilter: "blur(5px)",
              zIndex: 99999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "100%",
                maxWidth: "950px",
                maxHeight: "85vh",
                background: "#fff",
                borderRadius: "16px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
              }}
            >
              {/* Header */}
              <div
                style={{
                  padding: "20px 24px",
                  borderBottom: "1px solid #eee",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <h4 style={{ margin: 0, fontWeight: "700" }}>
                    Service Referrals
                  </h4>
                  <small style={{ color: "#888" }}>
                    All service referral records
                  </small>
                </div>

                <button
                  onClick={() => setShowServiceReferralsModal(false)}
                  style={{
                    width: "34px",
                    height: "34px",
                    border: "none",
                    borderRadius: "50%",
                    background: "#f1f1f1",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  ×
                </button>
              </div>

              {/* Body */}
              <div style={{ padding: "20px 24px", overflowY: "auto" }}>
                {referralsLoading ? (
                  <div style={{ textAlign: "center", padding: "40px" }}>
                    Loading product referrals...
                  </div>
                ) : serviceReferrals.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      color: "#888",
                    }}
                  >
                    No product referrals found.
                  </div>
                ) : (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(280px, 1fr))",
                      gap: "16px",
                    }}
                  >
                    {serviceReferrals.map((item, index) => (
                      <div
                        key={item?.id || index}
                        style={{
                          border: "1px solid #e5eaf0",
                          borderRadius: "12px",
                          overflow: "hidden",
                          background: "#fff",
                        }}
                      >
                        <div
                          style={{
                            padding: "13px 16px",
                            background: "#f0f6ff",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <strong style={{ color: "#245a9c" }}>
                            Service Referral #{item?.id}
                          </strong>

                          <span
                            style={{
                              fontSize: "11px",
                              padding: "4px 9px",
                              borderRadius: "20px",
                              background:
                                item?.isActive === true
                                  ? "#dcfce7"
                                  : item?.isActive === false
                                    ? "#fee2e2"
                                    : "#f1f5f9",
                              color:
                                item?.isActive === true
                                  ? "#15803d"
                                  : item?.isActive === false
                                    ? "#b91c1c"
                                    : "#64748b",
                            }}
                          >
                            {item?.isActive === true
                              ? "Active"
                              : item?.isActive === false
                                ? "Inactive"
                                : "Not Available"}
                          </span>
                        </div>

                        <div style={{ padding: "16px" }}>
                          {[
                            ["Referral ID", item?.id],
                            ["Patient ID", item?.patientId],
                            ["Patient Name", item?.patientName],
                            ["Service ID", item?.serviceId],
                            ["Patient Service ID", item?.patientServiceId],
                            ["Checkout ID", item?.checkoutId],
                            ["Product ID", item?.productId],
                            ["Customize Request ID", item?.customizeRequestId],
                            ["Store Sell ID", item?.storeSellId],
                            ["Referred By Name", item?.referredByName],
                            [
                              "Referred By Category ID",
                              item?.referredByCategoryId,
                            ],
                            [
                              "Referred By User ID",
                              item?.referredByCommonUserId,
                            ],
                            ["Referred Chamber ID", item?.referredChamberId],
                            ["Commission Amount", item?.commissionAmount],
                            ["Commission Rate", item?.commissionRate],
                            [
                              "Referred At",
                              item?.referredAt
                                ? new Date(item.referredAt).toLocaleString(
                                    "en-IN",
                                  )
                                : "-",
                            ],
                            ["Remarks", item?.remarks],
                          ].map(([label, value]) => (
                            <div
                              key={label}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "12px",
                                padding: "8px 0",
                                borderBottom: "1px solid #f1f3f5",
                                fontSize: "13px",
                              }}
                            >
                              <span style={{ color: "#777" }}>{label}</span>
                              <strong
                                style={{
                                  color: "#333",
                                  textAlign: "right",
                                  overflowWrap: "anywhere",
                                }}
                              >
                                {value ?? "-"}
                              </strong>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default Service;
